/**
 * @generated SignedSource<<dc90df5d3b35a44d74c35628a952f40f>>
 * @relayHash 0f6fe289a6ccc5643354c1a6f6908fee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d40955c5b82449dd974d5789356ab4028fae7bfa1831950a75706f6440159fc

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useConfluenceAutomationNudgeActionsQuery$variables = {
  contentId: string;
  includeContentReviewerNudge: boolean;
  includeStatusUpdatesAutomation: boolean;
  isDraft: boolean;
};
export type useConfluenceAutomationNudgeActionsQuery$data = {
  readonly singleContent: {
    readonly __typename: "Content";
    readonly contentReviewerContent?: {
      readonly " $fragmentSpreads": FragmentRefs<"useContentReviewerNudgeOnCriteria_content">;
    } | null;
    readonly id: string | null;
    readonly statusUpdatesAutomationContent?: {
      readonly " $fragmentSpreads": FragmentRefs<"useStatusUpdatesAutomationNudgeAction_content">;
    } | null;
  } | null;
  readonly user: {
    readonly __typename: "AtlassianUser";
    readonly id: string | null;
    readonly statusUpdatesAutomationUser?: {
      readonly " $fragmentSpreads": FragmentRefs<"useStatusUpdatesAutomationNudgeAction_user">;
    } | null;
  } | null;
};
export type useConfluenceAutomationNudgeActionsQuery = {
  response: useConfluenceAutomationNudgeActionsQuery$data;
  variables: useConfluenceAutomationNudgeActionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeContentReviewerNudge"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeStatusUpdatesAutomation"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v4 = [
  {
    "kind": "Literal",
    "name": "current",
    "value": true
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "isDraft",
    "variableName": "isDraft"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "title"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v4/*: any*/),
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "condition": "includeStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useStatusUpdatesAutomationNudgeAction_user"
                    }
                  ],
                  "type": "AtlassianUser"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "statusUpdatesAutomationUser"
              }
            ]
          }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
      },
      {
        "args": (v7/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "condition": "includeContentReviewerNudge",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": (v8/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "useContentReviewerNudgeOnCriteria_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentReviewerContent"
              }
            ]
          },
          {
            "condition": "includeStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useStatusUpdatesAutomationNudgeAction_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "statusUpdatesAutomationContent"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v4/*: any*/),
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "condition": "includeStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "AtlassianUserEmail",
                "kind": "LinkedField",
                "name": "emails",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
      },
      {
        "args": (v7/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "condition": "includeContentReviewerNudge",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v8/*: any*/),
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "contentState",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "unlocalizedName"
                  }
                ]
              }
            ]
          },
          {
            "condition": "includeStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v9/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ]
              },
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v9/*: any*/)
                ]
              },
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          }
                        ],
                        "type": "KnownUser"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "sourceTemplateEntityId"
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 25
                  }
                ],
                "concreteType": "PaginatedContentList",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v9/*: any*/),
                      {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "createdDate"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "children(first:25)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0f6fe289a6ccc5643354c1a6f6908fee",
    "id": "2d40955c5b82449dd974d5789356ab4028fae7bfa1831950a75706f6440159fc",
    "metadata": {},
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "operationKind": "query",
    "text": "query useConfluenceAutomationNudgeActionsQuery($contentId:ID!,$includeStatusUpdatesAutomation:Boolean!,$includeContentReviewerNudge:Boolean!,$isDraft:Boolean!){user:confluence_atlassianUser(current:true){__typename,id,...useStatusUpdatesAutomationNudgeAction_user@include(if:$includeStatusUpdatesAutomation)},singleContent(id:$contentId){__typename,id,...useContentReviewerNudgeOnCriteria_content_4FA06E@include(if:$includeContentReviewerNudge),...useStatusUpdatesAutomationNudgeAction_content@include(if:$includeStatusUpdatesAutomation)}}fragment useContentReviewerNudgeOnCriteria_content_4FA06E on Content{id,contentState(isDraft:$isDraft){id,name,unlocalizedName}}fragment useStatusUpdatesAutomationNudgeAction_content on Content{id,title,space{id},ancestors{id,title},history{ownedBy{__typename,...on KnownUser{accountId}}},metadata{sourceTemplateEntityId},children(first:25){nodes{id,title,metadata{createdDate}}}}fragment useStatusUpdatesAutomationNudgeAction_user on AtlassianUser{id,emails{value,isPrimary}}"
  }
};
})();

(node as any).hash = "cfd83dc7a307bf3ddde91b42f16827bd";

export default node;
